/* ChromaLabel "cost of label problems" calculator: DOM layer. Needs calc.js (window.ChromaROI).
   Options come from data attributes on each .clroi root:
   data-sample-url, data-quote-url, data-default-industry, data-show-context ("true" / "false").
   All text is set with textContent; config strings never go through innerHTML. */
(function () {
  'use strict';
  if (window.__clroiUiLoaded) return;
  window.__clroiUiLoaded = true;
  var R = window.ChromaROI;
  if (!R) return;
  var uid = 0;
  var PHONE = '(800) 256-0435';

  /** Creates an element. attrs: `class`, `text`, or any attribute; kids: nodes or strings. */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'text') el.textContent = v;
      else if (k === 'class') el.className = v;
      else el.setAttribute(k, v === true ? '' : v);
    });
    (kids || []).forEach(function (c) {
      if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }

  /** Formats a number for an input box, e.g. 20000 -> "20,000". */
  function fmt(n) { return n.toLocaleString('en-US', { maximumFractionDigits: 4 }); }

  /** Formats a number with its unit for messages, e.g. (75, '%') -> "75%", (500, '$') -> "$500". */
  function fmtU(n, unit) {
    var s = fmt(n);
    if (unit === '$') return '$' + s;
    if (unit === '%') return s + '%';
    if (unit === 'min' || unit === 'hrs') return s + ' ' + unit;
    return s;
  }

  /** Returns "about $X" using display rounding. */
  function about(n) { return 'about ' + R.formatUSD(n); }

  /** Builds the hero (kicker, h1, sub) when the page did not already render one. */
  function buildHero() {
    return h('header', { class: 'clroi-hero' }, [
      h('div', { class: 'clroi-kicker', text: 'Cost calculator' }),
      h('h1', { text: 'What are label problems costing you?' }),
      h('p', { class: 'clroi-hero__sub', text: 'Pick your industry and adjust the numbers to match your operation. Every starting number is either an industry estimate (with its source) or a placeholder for you to replace.' })
    ]);
  }

  /** Boots one calculator inside a .clroi root element. */
  function init(root) {
    var base = 'clroi' + (++uid);
    var ids = Object.keys(R.INDUSTRIES);
    var d = root.dataset;
    var defaultId = ids.indexOf(d.defaultIndustry) >= 0 ? d.defaultIndustry : ids[0];
    var sampleUrl = d.sampleUrl || '/pages/sample';
    var quoteUrl = d.quoteUrl || '/pages/contact-us';
    var showContext = d.showContext !== 'false';
    var mount = root.querySelector('[data-clroi-app]');
    if (!root.querySelector('.clroi-hero')) mount.parentNode.insertBefore(buildHero(), mount);

    var decoded = R.decodeState(location.search, defaultId);
    var industryId = decoded.industryId || defaultId;
    var values = Object.assign(R.defaultsFor(industryId), decoded.inputs);
    var srcNo = {};
    var lineEls = [];
    var announceTimer = null;
    var urlTimer = null;
    var booted = false;
    var impDef = R.SHARED_FIELDS.improvementPct;
    var premDef = R.SHARED_FIELDS.premiumPct;

    /** Pushes an analytics event (never any input values). */
    function track(action) {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'roi_calc', action: action, industry: industryId });
      }
    }

    /** Builds the small "Industry estimate" / "Placeholder" tag under an input. */
    function tag(def, id) {
      var src = def.kind === 'benchmark' && def.sourceId ? R.SOURCES[def.sourceId] : null;
      var p = h('p', { class: 'clroi-tag' + (src ? ' clroi-tag--src' : ''), id: id });
      if (src && srcNo[def.sourceId]) {
        p.appendChild(document.createTextNode('Industry estimate: '));
        p.appendChild(h('a', { href: '#' + base + '-src-' + srcNo[def.sourceId], text: src.publisher + ' ' + src.year }));
        (def.alsoSourceIds || []).forEach(function (sid) {
          var s2 = R.SOURCES[sid];
          if (!s2 || !srcNo[sid]) return;
          p.appendChild(document.createTextNode('; '));
          p.appendChild(h('a', { href: '#' + base + '-src-' + srcNo[sid], text: s2.publisher + ' ' + s2.year }));
        });
      } else {
        p.textContent = 'Placeholder: use your number';
      }
      if (def.note) p.appendChild(h('span', { class: 'clroi-hint', text: '. ' + def.note }));
      return p;
    }

    /** Wraps a text input with its unit prefix or suffix. */
    function ctl(input, unit) {
      var pre = unit === '$' ? h('span', { class: 'clroi-unit', 'aria-hidden': 'true', text: '$' }) : null;
      var suf = unit === '%' || unit === 'min' || unit === 'hrs' ? h('span', { class: 'clroi-unit', 'aria-hidden': 'true', text: unit }) : null;
      return h('div', { class: 'clroi-ctl' }, [pre, input, suf]);
    }

    /**
     * Creates a text input bound to values[key] with an inline error message.
     * Unparseable text keeps the last valid value; out-of-range text uses the clamped value.
     * Either way the message says what number the estimate is using.
     * @returns {{input: HTMLInputElement, err: HTMLElement, reset: function(): void}}
     */
    function bind(key, def, id, onChange) {
      var tagId = id + '-tag';
      var errId = id + '-err';
      var input = h('input', { type: 'text', id: id, inputmode: 'decimal', autocomplete: 'off', 'aria-describedby': tagId });
      var err = h('p', { class: 'clroi-err', id: errId, hidden: true });
      input.value = fmt(values[key]);

      /** Hides the message and restores the normal description. */
      function reset() {
        err.textContent = '';
        err.hidden = true;
        input.removeAttribute('aria-invalid');
        input.setAttribute('aria-describedby', tagId);
      }

      /** Shows `msg` under the input and links it to the input. */
      function show(msg) {
        err.textContent = msg;
        err.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', errId + ' ' + tagId);
      }

      /** Validates the typed text and updates values[key] and the message. */
      function check(text) {
        var n = R.parseNumber(text);
        var range = 'Enter a number from ' + fmtU(def.min, def.unit) + ' to ' + fmtU(def.max, def.unit) + '.';
        if (isNaN(n)) {
          if (/^[\s,$%]*$/.test(text) && def.min === 0) { values[key] = 0; reset(); return; }
          show(range + ' Still using ' + fmtU(values[key], def.unit) + '.');
        } else if (n < def.min) {
          values[key] = def.min;
          show(range + ' Using ' + fmtU(def.min, def.unit) + ', the minimum.');
        } else if (n > def.max) {
          values[key] = def.max;
          show(range + ' Using ' + fmtU(def.max, def.unit) + ', the maximum.');
        } else {
          values[key] = n;
          reset();
        }
      }

      input.addEventListener('input', function () {
        check(input.value);
        if (onChange) onChange();
        update(false);
      });
      input.addEventListener('blur', function () {
        if (input.getAttribute('aria-invalid') !== 'true') input.value = fmt(values[key]);
      });
      return { input: input, err: err, reset: reset };
    }

    /** Builds one labelled field with its source tag. */
    function field(key, def) {
      var id = base + '-' + key.replace('.', '-');
      var b = bind(key, def, id);
      return h('div', { class: 'clroi-field' }, [h('label', { for: id, text: def.label }), ctl(b.input, def.unit), b.err, tag(def, id + '-tag')]);
    }

    /** Rebuilds the basics and per-driver fieldsets for the current industry. */
    function buildFields() {
      var defs = R.fieldDefs(industryId);
      var ind = R.getIndustry(industryId);
      els.fields.textContent = '';
      els.fields.appendChild(h('fieldset', { class: 'clroi-card clroi-set' }, [
        h('legend', { text: 'Your basics' }),
        h('div', { class: 'clroi-grid' }, ['labelSpend', 'hourly', 'workdays'].map(function (k) { return field(k, defs[k]); }))
      ]));
      ind.drivers.forEach(function (dr) {
        els.fields.appendChild(h('fieldset', { class: 'clroi-card clroi-set' }, [
          h('legend', { text: dr.title }),
          h('p', { class: 'clroi-why', text: dr.why }),
          h('div', { class: 'clroi-grid' }, Object.keys(dr.fields).map(function (k) { return field(dr.id + '.' + k, defs[dr.id + '.' + k]); }))
        ]));
      });
    }

    /** Rebuilds the breakdown rows (name, amount, decorative bar) for the current industry. */
    function buildLines() {
      els.lines.textContent = '';
      lineEls = R.getIndustry(industryId).drivers.map(function (dr) {
        var amt = h('span', { class: 'clroi-line__amt' });
        var bar = h('i');
        els.lines.appendChild(h('li', { class: 'clroi-line' }, [
          h('div', { class: 'clroi-line__row' }, [h('span', { class: 'clroi-line__name', text: dr.title }), amt]),
          h('div', { class: 'clroi-bar', 'aria-hidden': 'true' }, [bar])
        ]));
        return { amt: amt, bar: bar };
      });
    }

    /** Rebuilds the compliance context box (never added to the dollar total). */
    function buildContext() {
      var items = R.getIndustry(industryId).context || [];
      els.context.textContent = '';
      els.context.hidden = !showContext || !items.length;
      if (els.context.hidden) return;
      els.context.appendChild(h('h2', { text: 'Why it matters beyond dollars' }));
      els.context.appendChild(h('ul', { class: 'clroi-list' }, items.map(function (c) {
        var n = srcNo[c.sourceId];
        return h('li', {}, [c.text + ' ', n ? h('a', { href: '#' + base + '-src-' + n, 'aria-label': 'Source ' + n, text: '[' + n + ']' }) : null]);
      })));
      els.context.appendChild(h('p', { class: 'clroi-small', text: 'These facts are not included in the estimate above.' }));
    }

    /** Rebuilds the numbered sources list and the plain-word formulas for the current industry. */
    function buildSources() {
      var ind = R.getIndustry(industryId);
      var list = R.sourceIdsFor(industryId);
      els.sources.textContent = '';
      els.sources.appendChild(h('h2', { text: 'Sources and assumptions' }));
      if (list.length) {
        els.sources.appendChild(h('ol', { class: 'clroi-srcs' }, list.map(function (sid, i) {
          var s = R.SOURCES[sid];
          return h('li', { id: base + '-src-' + (i + 1) }, [
            s.publisher + ', ' + s.title + ' (' + s.year + '). ',
            h('a', { href: s.url, rel: 'noopener', target: '_blank', text: s.url }),
            s.quote ? h('span', { class: 'clroi-quote', text: ' “' + s.quote + '”' }) : null
          ]);
        })));
      }
      els.sources.appendChild(h('p', { text: 'Numbers marked “Placeholder” have no source. They are starting points for you to replace with your own.' }));
      els.sources.appendChild(h('h3', { text: 'How each line is calculated' }));
      var rows = ind.drivers.map(function (dr) {
        return h('li', {}, [h('strong', { text: dr.title + ': ' }), R.FORMULA_WORDS[dr.type] || '']);
      });
      rows.push(h('li', {}, [h('strong', { text: 'Savings: ' }), 'total cost × the share better labels could prevent.']));
      rows.push(h('li', {}, [h('strong', { text: 'Net: ' }), 'savings minus the extra cost of upgraded labels (label spend × extra cost %).']));
      els.sources.appendChild(h('ul', { class: 'clroi-list' }, rows));
    }

    /** Builds the shared "share of costs prevented" slider and "extra cost" number controls. */
    function buildTune() {
      var slider = h('input', { type: 'range', min: impDef.min, max: impDef.max, step: impDef.step, 'aria-label': impDef.label + ' (slider)' });
      var imp = bind('improvementPct', impDef, base + '-imp', function () { slider.value = values.improvementPct; });
      var prem = bind('premiumPct', premDef, base + '-prem');
      slider.addEventListener('input', function () {
        values.improvementPct = R.sanitize(slider.value, impDef);
        imp.input.value = fmt(values.improvementPct);
        imp.reset();
        update(false);
      });
      els.sync = function () {
        slider.value = values.improvementPct;
        imp.input.value = fmt(values.improvementPct);
        prem.input.value = fmt(values.premiumPct);
        imp.reset();
        prem.reset();
      };
      return h('div', { class: 'clroi-tune' }, [
        h('label', { for: base + '-imp', text: impDef.label }),
        h('div', { class: 'clroi-tune__row' }, [slider, ctl(imp.input, '%')]),
        imp.err,
        tag(impDef, base + '-imp-tag'),
        h('label', { for: base + '-prem', text: premDef.label }),
        ctl(prem.input, '%'),
        prem.err,
        tag(premDef, base + '-prem-tag')
      ]);
    }

    /** Builds the net-result sentence for a verdict. */
    function netText(r) {
      if (r.verdict === 'empty') return 'Enter your numbers to see what better labels could be worth.';
      if (r.verdict === 'doesnt') {
        return 'At these numbers, upgraded labels may not pay for themselves on cost alone. Fit, compliance and safety may still matter; we’re happy to talk it through.';
      }
      var s = 'If better-fitting labels prevented ' + fmt(r.improvementPct) + '% of that, you’d save ' + about(r.savings) + ' a year.';
      if (r.addedLabelSpend > 0) {
        s += ' Even paying ' + fmt(r.premiumPct) + '% more for labels (+' + R.formatUSD(r.addedLabelSpend) + '), you’d come out ' + about(r.net) + ' ahead.';
      }
      return s;
    }

    /** Writes the headline (not a live region; the hidden status region announces changes). */
    function paintHeadline(r) {
      els.headline.textContent = '';
      if (r.verdict === 'empty') { els.headline.textContent = 'Enter your numbers to see an estimate.'; return; }
      els.headline.appendChild(document.createTextNode(R.getIndustry(r.industryId).headline + ' '));
      els.headline.appendChild(h('strong', { text: about(r.totalCost) + ' a year' }));
    }

    /** Current query string for the share link and address bar. */
    function currentQuery() {
      var p = new URLSearchParams(location.search);
      R.stateKeys().forEach(function (k) { p.delete(k); });
      var mine = new URLSearchParams(R.encodeState(industryId, values));
      if (industryId === defaultId && mine.toString() === 'i=' + industryId) mine = new URLSearchParams();
      mine.forEach(function (v, k) { p.set(k, v); });
      var q = p.toString();
      return q ? '?' + q : '';
    }

    /** Builds the short sentence the status region announces: total, savings and net or verdict. */
    function announceText(r) {
      if (r.verdict === 'empty') return 'Enter your numbers to see an estimate.';
      var s = 'Estimated cost ' + about(r.totalCost) + ' a year. Better labels could save ' + about(r.savings) + '.';
      s += r.verdict === 'pays'
        ? ' Net of the extra label cost, about ' + R.formatUSD(r.net) + ' ahead.'
        : ' Upgraded labels may not pay for themselves on cost alone.';
      return s;
    }

    /** Announces the result in the hidden status region, debounced 250 ms. Silent during boot. */
    function announce(r) {
      if (!booted) return;
      clearTimeout(announceTimer);
      announceTimer = setTimeout(function () { els.live.textContent = announceText(r); }, 250);
    }

    /** Writes the address bar now, keeping history.state and skipping the write when the URL is unchanged. */
    function writeUrl() {
      clearTimeout(urlTimer);
      var next = location.pathname + currentQuery() + location.hash;
      if (next === location.pathname + location.search + location.hash) return;
      try { history.replaceState(history.state, '', next); } catch (e) { /* file:// or sandboxed */ }
    }

    /** Recomputes and repaints everything. `now` (industry change) writes the URL immediately; otherwise it is debounced 400 ms. */
    function update(now) {
      var r = R.computeROI(industryId, values);
      lineEls.forEach(function (e, i) {
        var l = r.lines[i];
        e.amt.textContent = R.formatUSD(l.annual);
        e.bar.style.width = (r.totalCost > 0 ? l.annual / r.totalCost * 100 : 0).toFixed(1) + '%';
      });
      var m = r.multipleOfSpend;
      els.multiple.hidden = m === null || r.verdict === 'empty';
      if (!els.multiple.hidden) {
        els.multiple.textContent = m >= 1
          ? 'That’s about ' + (m >= 10 ? Math.round(m) : Math.round(m * 10) / 10) + '× what you spend on labels.'
          : 'That’s about ' + Math.round(m * 100) + '% of what you spend on labels.';
      }
      els.net.textContent = netText(r);
      els.net.setAttribute('data-verdict', r.verdict);
      paintHeadline(r);
      announce(r);
      if (!booted) return;
      if (now) writeUrl(); else { clearTimeout(urlTimer); urlTimer = setTimeout(writeUrl, 400); }
    }

    /** Rebuilds everything that depends on the industry. */
    function rebuild() {
      srcNo = {};
      R.sourceIdsFor(industryId).forEach(function (sid, i) { srcNo[sid] = i + 1; });
      buildFields();
      buildLines();
      buildContext();
      buildSources();
      els.sync();
    }

    /** Full URL for the share link. */
    function shareUrl() { return location.href.split(/[?#]/)[0] + currentQuery(); }

    /** Copies the share link, or reveals a selectable text box when the clipboard is unavailable. */
    function share() {
      var url = shareUrl();
      track('share');
      /** Shows the manual-copy fallback. */
      function manual() {
        els.shareBox.hidden = false;
        els.shareBox.value = url;
        els.shareBox.focus();
        els.shareBox.select();
        els.status.textContent = 'Copy the link below.';
      }
      try {
        navigator.clipboard.writeText(url).then(function () {
          els.shareBox.hidden = true;
          els.status.textContent = 'Link copied. Paste it into an email or message.';
        }, manual);
      } catch (e) { manual(); }
    }

    // ---- skeleton ----
    var els = { sync: function () {} };
    els.fields = h('div', { class: 'clroi-fields' });
    els.headline = h('p', { class: 'clroi-headline' });
    els.live = h('p', { class: 'clroi-sr', role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' });
    els.lines = h('ul', { class: 'clroi-lines' });
    els.multiple = h('p', { class: 'clroi-multiple' });
    els.net = h('p', { class: 'clroi-net' });
    els.status = h('span', { class: 'clroi-status', role: 'status' });
    els.shareBox = h('input', { type: 'text', class: 'clroi-sharebox', readonly: true, 'aria-label': 'Link to share', hidden: true });
    els.context = h('section', { class: 'clroi-card clroi-context' });
    els.sources = h('section', { class: 'clroi-card clroi-sources' });

    var picker = h('div', { class: 'clroi-opts' });
    ids.forEach(function (id) {
      var ind = R.INDUSTRIES[id];
      var radio = h('input', { type: 'radio', name: base + '-industry', value: id });
      radio.checked = id === industryId;
      picker.appendChild(h('label', { class: 'clroi-opt' }, [radio, h('span', { class: 'clroi-opt__box' }, [
        h('span', { class: 'clroi-opt__name', text: ind.name }),
        h('span', { class: 'clroi-opt__ex', text: ind.examples })
      ])]));
    });
    picker.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      industryId = e.target.value;
      values = R.defaultsFor(industryId);
      rebuild();
      update(true);
      track('industry');
    });

    var printBtn = h('button', { type: 'button', class: 'clroi-btn clroi-btn--text', text: 'Print or save as PDF' });
    printBtn.addEventListener('click', function () { track('print'); window.print(); });
    var shareBtn = h('button', { type: 'button', class: 'clroi-btn clroi-btn--text', text: 'Share these numbers' });
    shareBtn.addEventListener('click', share);

    var results = h('aside', { class: 'clroi-card clroi-results', id: base + '-results', tabindex: '-1', 'aria-label': 'Your estimate' }, [
      els.live,
      els.headline,
      els.lines,
      els.multiple,
      buildTune(),
      els.net,
      h('div', { class: 'clroi-cta' }, [
        h('a', { class: 'clroi-btn clroi-btn--primary', href: sampleUrl, 'data-cta': 'sample', text: 'Get free samples' }),
        h('a', { class: 'clroi-btn clroi-btn--ghost', href: quoteUrl, 'data-cta': 'quote', text: 'Request a custom quote' })
      ]),
      h('div', { class: 'clroi-tools' }, [shareBtn, printBtn, els.status]),
      els.shareBox,
      h('p', { class: 'clroi-small', text: 'Prefer to talk? Call ' }, [h('a', { href: 'tel:+18002560435', text: PHONE })])
    ]);

    root.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-cta]') : null;
      if (a) track('cta');
    });

    var app = h('div', { class: 'clroi-app' }, [
      h('a', { class: 'clroi-skip', href: '#' + base + '-results', text: 'See your estimate' }),
      h('div', { class: 'clroi-layout' }, [
        h('div', { class: 'clroi-main' }, [
          h('fieldset', { class: 'clroi-card clroi-set clroi-industry' }, [h('legend', { text: 'Your industry' }), picker]),
          els.fields
        ]),
        results
      ]),
      els.context,
      els.sources,
      h('p', { class: 'clroi-disclaimer', text: 'These are planning estimates built from published industry studies and the numbers you enter. Your results will differ. ChromaLabel does not guarantee specific savings.' })
    ]);

    rebuild();
    update(true);
    mount.textContent = '';
    mount.appendChild(app);
    root.classList.add('clroi--ready');
    booted = true;
    writeUrl(); // only changes the address bar when the incoming URL needed normalizing
  }

  /** Boots one .clroi root, once. Roots without a [data-clroi-app] mount are skipped. */
  function boot(rootEl) {
    if (!rootEl || rootEl.getAttribute('data-clroi-init')) return;
    if (!rootEl.querySelector('[data-clroi-app]')) return;
    rootEl.setAttribute('data-clroi-init', '1');
    try { init(rootEl); } catch (err) { if (window.console) console.error('ChromaROI failed to start', err); }
  }

  /** Boots every .clroi root inside `scope` (and `scope` itself when it is one). */
  function bootWithin(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('.clroi')) boot(scope);
    Array.prototype.forEach.call(scope.querySelectorAll('.clroi'), boot);
  }

  /** Boots all roots on the page. */
  function bootAll() { bootWithin(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();

  // Shopify theme editor re-renders a section in place and fires this event on the new section element.
  document.addEventListener('shopify:section:load', function (e) { bootWithin(e.target); });
})();
